export function ensureHttps(url?: string): string {
  if (!url) return '';
  if (!url.startsWith('https://')) {
    return 'https://' + url;
  }
  return url;
}
